/*
	router中的main对应视图层view底下的main
	此处合并main下各功能页面中的router内容
*/
import home from './home/index';
export default [
	...home,
]


// WEBPACK FOOTER //
// ./src/router/main/index.js